import Svg, { Path } from 'react-native-svg';
import { withDefaultIconProps } from './index';

export const SuperRibbon = withDefaultIconProps(
  {
    height: 32,
    width: 33,
  },
  ({ color, ...rest }) => (
    <Svg {...rest} viewBox="0 0 30 30">
      <Path
        d="M23.38 12.11C23.38 9.88 22.5 7.77 20.92 6.19C19.34 4.61 17.24 3.74 15 3.74C12.76 3.74 10.66 4.61 9.08 6.19C7.49 7.77 6.62 9.88 6.62 12.11C6.62 14.35 7.49 16.45 9.08 18.04C9.12 18.08 9.17 18.12 9.21 18.17V25.5C9.21 25.79 9.37 26.05 9.63 26.18C9.89 26.31 10.19 26.29 10.43 26.12L15 22.77L19.57 26.12C19.71 26.21 19.87 26.26 20.03 26.26C20.14 26.26 20.26 26.24 20.37 26.18C20.63 26.05 20.79 25.79 20.79 25.5V18.17C20.83 18.12 20.88 18.08 20.92 18.04C22.5 16.45 23.38 14.35 23.38 12.11ZM8.15 12.11C8.15 10.28 8.86 8.56 10.16 7.27C11.45 5.98 13.17 5.26 15 5.26C16.83 5.26 18.55 5.98 19.84 7.27C21.14 8.56 21.85 10.28 21.85 12.11C21.85 13.94 21.14 15.66 19.84 16.96C18.55 18.25 16.83 18.96 15 18.96C13.17 18.96 11.45 18.25 10.16 16.96C8.86 15.66 8.15 13.94 8.15 12.11ZM19.26 24L15.45 21.21C15.18 21.01 14.82 21.01 14.55 21.21L10.74 24V19.33C12.02 20.08 13.48 20.49 15 20.49C16.52 20.49 17.98 20.08 19.26 19.33V24Z"
        fill={color}
      />
    </Svg>
  ),
);
